<!-- <section class="footer-area pt-100 pb-70"> -->
<section class="footer-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo">
                        <div class="total_logo">
                            <div class="logo1">
                                <img src="assets/img/logo/zyro-image.png" alt="logo">
                            </div>
                            <div class="logo2">
                                <span class="logo_name"><h2>CityDiscovery</h2></span>
                                <span class="logo_meaning"><h6>Tourist App</h6></span>
                            </div>
                        </div>

                    </a>
                    <p>{{'col1_footer_1' | translate}}</p>
                    <p>Email: hello@citydiscovery.com</p>
                    <p>Hotline: 0902 527 421</p>
                    <p>{{'col1_footer_2' | translate}}</p>
                    <ul class="social-list">
                        <li><a href="#" target="_blank"><i class="fab fa-facebook-f"><fa-icon [icon]="faFacebookF"></fa-icon></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-twitter"><fa-icon [icon]="faTwitter"></fa-icon></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-linkedin-in"><fa-icon [icon]="faLinkedinIn"></fa-icon></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-instagram"><fa-icon [icon]="faInstagram"></fa-icon></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>{{'col2_footer_1' | translate}}</h3>
                    <div class="company_bar"></div>
                    <ul class="list">
                        <li><a routerLink="/">{{'col2_footer_2' | translate}}</a></li>
                        <li><a routerLink="/">Quest</a></li>
                        <li><a routerLink="/">{{'col2_footer_3' | translate}}</a></li>
                        <li><a routerLink="/">{{'col2_footer_4' | translate}}</a></li>
                        <li><a routerLink="/">{{'col2_footer_5' | translate}}</a></li>

                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <h3>{{'col3_footer_1' | translate}}</h3>
                    <div class="contact_bar"></div>
                    <ul class="list">
                        <li><a routerLink="/">{{'col3_footer_2' | translate}}</a></li>
                        <li><a routerLink="/">{{'col3_footer_3' | translate}}</a></li>
                        <li><a routerLink="/">{{'col3_footer_4' | translate}}</a></li>
                        <li><a routerLink="/">{{'col3_footer_5' | translate}}</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <h3> {{'download_msg' | translate}} </h3>
                    <div class="download_bar"></div>
                    <ul class="footer-holder">
                        <li><a href="#"><img src="assets/img/store/1.png" alt="image"></a></li>
                        <li><a href="#"><img src="assets/img/store/2.png" alt="image"></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="copy-right">
    <div class="container">
        <div class="copy-right-content">
            <p>
                Copyright <i class="far fa-copyright">© </i> <a class="app_name" href="">CityDiscovery</a>. All Rights Reserved.
            </p>
        </div>
    </div>
</div>

<div class="go-top">
    <i class="fa fa-chevron-up"><fa-icon [icon]="faChevronUp"></fa-icon></i>
    <i class="fa fa-chevron-up"><fa-icon [icon]="faChevronUp"></fa-icon></i>
</div>


